/**
 * Garde-fou chargé AVANT tout autre module de l'application.
 *
 * Si public/env.js n'est pas chargé ou est invalide, window.env est
 * indéfini : toute lecture de env.X au niveau module lèverait une
 * TypeError pendant l'évaluation des imports -> page blanche avant
 * même le montage de React. On garantit donc un objet par défaut.
 */
const w = window as any;
if (!w.env || typeof w.env !== 'object') {
    w.env = {};
}

/**
 * Relais des erreurs globales (hors rendu React : handlers, promesses
 * rejetées, timers) vers le système d'alertes visuelles. Écoute
 * 'eb:global-error' -> affiche un toast au lieu d'un échec silencieux.
 */
const reportGlobalError = (message: string) => {
    try {
        window.dispatchEvent(new CustomEvent('eb:global-error', { detail: message }));
    } catch { /* ne jamais planter depuis le handler d'erreurs */ }
};

window.addEventListener('error', (e: ErrorEvent) => {
    if (!e.error && !e.message) return;
    console.error('[global-error]', e.error || e.message);
    reportGlobalError(e.error?.message || e.message || 'Erreur inattendue');
});

window.addEventListener('unhandledrejection', (e: PromiseRejectionEvent) => {
    const reason: any = e.reason;
    console.error('[unhandled-rejection]', reason);
    reportGlobalError(reason?.message || String(reason || 'Erreur interne'));
});

export {};
